var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.userInfo.type === 'A' || _vm.$store.state.userInfo.type === 'CL')?_c('vx-card',{attrs:{"title":_vm.$t('labels.edit_profile')}},[_c('div',[_c('basic-details')],1)]):_vm._e(),(_vm.$store.state.userInfo.type === 'CN')?_c('div',[_c('consultant-details')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }